import "./DetailsTable.css";
import { getTranslatedText as translate } from "../../Localization/Translation";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";

function DetailsTable() {
  const { locale, selectedOrderIndex, MyOrders } = useBetween(
    useSelector((state) => state.useSharedState)
  );
  const deliveringOrdersTypes = useSelector(
    (state) => state.deliveringOrdersTypes
  );
  const order = MyOrders[selectedOrderIndex];

  return (
    <div className="DetailsTable">
      <div className="mb-3">
        <p className="card-text">
          <span className="orders-label-card">
            <i
              className="bi bi-person-fill"
              style={{ color: "rgba(14, 133, 230, 255)" }}
            ></i>
            {translate("Laundry-name-label-order", locale)}
          </span>
          {order.LaundryName}
        </p>
        {order.done ? (
          <p className="card-text">
            <span className="orders-label-card">
              <i
                className="bi bi-person-fill"
                style={{ color: "rgba(14, 133, 230, 255)" }}
              ></i>
              {translate("Delivery-name-label-order", locale)}
            </span>
            {order.DeliveryName}
          </p>
        ) : (
          <></>
        )}
        <p className="card-text">
          <span className="orders-label-card">
            <i
              className="bi bi-calendar-week-fill"
              style={{ color: "rgba(14, 133, 230, 255)" }}
            ></i>
            {translate("Date-label-order", locale)}
          </span>
          {order.date}
        </p>
        <p className="card-text">
          <span className="orders-label-card">
            <i
              className="bi bi-three-dots"
              style={{ color: "rgba(14, 133, 230, 255)" }}
            ></i>
            {translate("Type-label-order", locale)}
          </span>
          {order.type === 1
            ? translate(deliveringOrdersTypes[1], locale)
            : translate(deliveringOrdersTypes[0], locale)}
        </p>
      </div>
      <div className="table-container-notification">
        <table className="table" dir="auto">
          <thead className="thead-dark">
            <tr className="table-notification-details-header">
              <th scope="col">#</th>
              <th scope="col">{translate("item-type-column", locale)}</th>
              <th scope="col">{translate("service-type-column", locale)}</th>
              <th scope="col">{translate("number-of-items-column", locale)}</th>
              <th scope="col">{translate("price-column", locale)}</th>
            </tr>
          </thead>
          <tbody>
            {order.detailedOrder.map((detail, index) => {
              return (
                <tr key={detail.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{detail.itemType}</td>
                  <td>
                    {detail.serviceTypes.map((type, indexType) => {
                      if (indexType !== detail.serviceTypes.length - 1)
                        return type + " - ";
                      else return type;
                    })}
                  </td>
                  <td>{detail.numberOfItems}</td>
                  <td>{detail.price}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* <hr /> */}
      <div className="prices-container">
        <div>
          <span className="price-label-modal">
            {translate("price-cost-label-modal", locale)}
          </span>
          <span>
            {order.cost} {translate("currency", locale)}
          </span>
        </div>
        <div>
          <span className="price-label-modal">
            {translate("price-commission-label-modal", locale)}
          </span>
          <span>
            {order.commision} {translate("currency", locale)}
          </span>
        </div>
        <hr />
        <div>
          <span className="price-label-modal">
            {translate("price-label-modal", locale)}
          </span>
          <span>
            {order.totalPrice} {translate("currency", locale)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default DetailsTable;
